import { atom } from "recoil"

export const onlineAtom = atom<boolean>({
  key: "userAtom",
  default: true,
})
